export default __webpack_public_path__ + "static/media/ahmed.f6ed4904.jpeg";